import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full bg-cream pt-10 pb-6 px-6 overflow-hidden" data-id="element-53">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-54">
        {/* Minimal Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-4" data-id="element-55">
          <span className="text-xs uppercase tracking-[0.2em] text-coffee-medium border-b border-coffee-medium/30 pb-1" data-id="element-56">
            Los Secretos del Café Colombiano
          </span>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-3xl md:text-5xl font-serif text-coffee-dark mb-4 leading-[1.1]" data-id="element-57">
          Domina el Arte del Café en 7 días{' '}
          <span className="italic font-light text-coffee" data-id="element-58">
            con +400 recetas únicas
          </span>
        </motion.h1>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="w-full max-w-xs mx-auto" data-id="element-59">
          <img src="https://cdn.magicpatterns.com/uploads/v6vCxvUoCyh1A2aNrQWJdQ/hf_20260201_172736_b8f81790-c594-4982-9ad7-14efcb091817.png" alt="Los Secretos del Café Colombiano en Tablet" className="w-full h-auto rounded-lg shadow-xl shadow-coffee-dark/15" data-id="element-60" />
        </motion.div>
      </div>
    </section>;
}